import { Avatar, styled, Typography } from "@material-ui/core";
import LocalDrink from "@material-ui/icons/LocalDrink";
import { brand } from "../theme";

export const Card = styled("div")(({ theme }) => ({
  background: brand.white,
  display: "flex",
  gap: theme.spacing(2),
  padding: theme.spacing(2.5, 2.5, 2.25),
  alignItems: "flex-start",
  borderBottom: `1px solid ${brand.sep}`,
  "&:last-child": {
    borderBottom: "none",
  },
}));

export const BottleColumn = styled("div")(({ theme }) => ({
  flexShrink: 0,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: theme.spacing(1.25),
  paddingTop: theme.spacing(1.25),
}));

export const BottleImage = styled(({ beer, imageUrl, ...p }) => (
  <Avatar
    variant={imageUrl ? "square" : "circle"}
    alt={beer?.displayName ?? ""}
    src={imageUrl ?? undefined}
    {...p}
  >
    <LocalDrink />
  </Avatar>
))({
  height: 110,
  width: 58,
  background: "transparent",
  "& .MuiAvatar-img": {
    objectFit: "contain",
  },
  "& .MuiSvgIcon-root": {
    color: brand.amberDeep,
    fontSize: 36,
  },
});

export const RoundChip = styled("div")({
  fontSize: 9,
  fontWeight: 800,
  letterSpacing: 0.7,
  color: brand.amberDeep,
  background: brand.amberLight,
  padding: "3px 8px",
  borderRadius: 999,
  textTransform: "uppercase",
});

export const Body = styled("div")({
  flex: 1,
  minWidth: 0,
});

export const Name = styled((p) => <Typography variant="h5" {...p} />)(
  ({ theme }) => ({
    fontSize: 20,
    fontWeight: 700,
    letterSpacing: -0.3,
    color: brand.text,
    marginBottom: theme.spacing(1.5),
    lineHeight: 1.15,
  }),
);

export const Para = styled("div")(({ theme }) => ({
  fontSize: 14,
  lineHeight: 1.5,
  marginBottom: theme.spacing(1.25),
  color: brand.textSec,
  "&:last-child": {
    marginBottom: 0,
  },
  "& .label": {
    fontWeight: 700,
    color: brand.text,
    marginRight: 2,
  },
}));
